import React from 'react'

import CompetitorEventRegisterWrapper from '../../CompetitorEventRegisterWrapper'
import { CommentsQuestion } from '../../../organizer/manage/components/CommentsQuestion'

import { useAppDispatch, useAppSelector } from '../../../../store/hooks'

import { convertUrlsToLinks } from '../../../../helpers/convertUrlToLinks'

import { IEventInterface, IQuestion } from '../../../../models/events/event.interface'
import { IAnswer } from '../../../../models/event-registered-users/event-registered-users.interface'
import {
  selectRegistration,
  setRegistrationAc,
} from '../../../../store/registration/registrationSlice'

interface IProps {
  event: IEventInterface | null | undefined
  comments: IAnswer[]
}

export const CompetitorEventRegisterComments: React.FC<IProps> = ({ event, comments }) => {
  const dispatch = useAppDispatch()

  const registration = useAppSelector(selectRegistration)

  const newComments = [...comments]

  const handlerChangeComment = (value: string, question: IQuestion) => {
    if (!registration) return

    const currentCommentIndex = newComments.findIndex((c) => c.questionId === question.id)

    if (currentCommentIndex >= 0) {
      newComments[currentCommentIndex] = {
        ...newComments[currentCommentIndex],
        answer: value,
      }

      dispatch(setRegistrationAc({ ...registration, answers: newComments }))

      return null
    }

    const newData = [...newComments]

    newData.push({
      answer: value,
      id: `${new Date().getTime()}`,
      questionId: question.id,
      files: [],
    })

    dispatch(setRegistrationAc({ ...registration, answers: newData }))
    return null
  }

  const addFile = (value: string, question: IQuestion) => {
    if (!registration) return

    const currentCommentIndex = newComments.findIndex((c) => c.questionId === question.id)

    if (currentCommentIndex >= 0) {
      newComments[currentCommentIndex] = {
        ...newComments[currentCommentIndex],
        files: [...newComments[currentCommentIndex].files, value],
      }

      dispatch(setRegistrationAc({ ...registration, answers: newComments }))
      return null
    }

    const newData = [...newComments]

    newData.push({
      answer: '',
      id: `${new Date().getTime()}`,
      questionId: question.id,
      files: [value],
    })

    dispatch(setRegistrationAc({ ...registration, answers: newData }))
    return null
  }

  const removeFile = (index: number, question: IQuestion) => {
    if (!registration) return

    const currentCommentIndex = newComments.findIndex((c) => c.questionId === question.id)

    if (currentCommentIndex < 0) {
      return null
    }
    const newData = [...newComments]

    const newFiles = [...newData[currentCommentIndex].files]
    newFiles.splice(index, 1)

    newData[currentCommentIndex] = {
      ...newData[currentCommentIndex],
      files: newFiles,
    }

    dispatch(setRegistrationAc({ ...registration, answers: newData }))
  }
  const renderBody = () => {
    if (!event) {
      return <>No event data</>
    }

    if (!Array.isArray(event.questions) || !event.questions[0]) {
      return <h3>No questions</h3>
    }

    return event.questions?.map((question) => {
      const currentComment = comments.find((c) => c.questionId === question.id)

      return (
        <div
          key={question.id}
          className="flex gap-8 w-full mt-8 border p-5 border-black/10 rounded-xl"
        >
          <div className="w-full">
            <div className="mb-6 flex items-center gap-2 justify-between">
              <h4 className="font-medium text-SeabiscuitDark200ThemeColor text-base flex flex-wrap items-center gap-1">
                <span dangerouslySetInnerHTML={{ __html: convertUrlsToLinks(question.value) }} />{' '}
                {question.isRequired && (
                  <span className="text-SeabiscuitMainThemeColor text-[10px]">(required)</span>
                )}
              </h4>
            </div>
            <CommentsQuestion
              addFile={(v) => addFile(v, question)}
              files={currentComment?.files || []}
              questionId={question.id}
              defaultValue={currentComment?.answer || ''}
              handleChange={(value) => handlerChangeComment(value, question)}
              removeFile={(v, i) => removeFile(i, question)}
            />
          </div>
        </div>
      )
    })
  }

  return (
    <CompetitorEventRegisterWrapper
      title={'Comments'}
      description={'Add comments for show management'}
    >
      {renderBody()}
    </CompetitorEventRegisterWrapper>
  )
}
